import { FormEvent, SetStateAction } from "react"

import { useLazyGetParentCompaniesQuery } from "store/api/dictionaryApi"
import { UITypes } from "types"

import ModalSectionTitle from "components/common/ModalSectionTitle/ModalSectionTitle"
import { InputNew } from "components/form/InputNew"
import { SelectDynamic } from "components/form/SelectDynamic"

import { AddressFields } from "./AddressFields"

import styles from "./index.module.scss"

interface Props {
  inputValues: UITypes.Contractor
  error: {
    field: string
    message: string
  }
  onInputChange: (event: FormEvent<HTMLInputElement>) => void
  setInputValues: (value: SetStateAction<UITypes.Contractor>) => void
}

const DetailsSection = ({ inputValues, error, onInputChange, setInputValues }: Props) => {
  return (
    <div>
      <ModalSectionTitle title="Details" />
      <div className={styles.row}>
        <InputNew
          label="Company name"
          placeholder="Enter company name"
          name="name"
          value={inputValues.name}
          className={styles.inputText}
          onChange={onInputChange}
          errorMessage={error.field === "name" ? error.message : ""}
        />
      </div>
      <div className={styles.row}>
        <InputNew
          label="Brand name"
          placeholder="Enter brand name"
          name="brand"
          value={inputValues.brand}
          className={styles.inputText}
          onChange={onInputChange}
          errorMessage={error.field === "brand" ? error.message : ""}
        />
        <SelectDynamic
          label="Parent company"
          placeholder="Select the parent company"
          searchFieldName="name"
          valueName="id"
          labelName="name"
          name="parent_company"
          values={inputValues.parentCompany || []}
          className={styles.inputText}
          useLazyQuery={useLazyGetParentCompaniesQuery}
          onChange={value => setInputValues({ ...inputValues, ...{ parentCompany: value } })}
          errorMessage={error.field === "parent_company" ? error.message : ""}
          queryParams={{ country_id: (inputValues.country?.[0]?.value || 1) as unknown as number }}
          backspaceDelete
        />
      </div>
      <AddressFields
        inputValues={inputValues}
        error={error}
        onInputChange={onInputChange}
        setInputValues={setInputValues}
      />
    </div>
  )
}

export default DetailsSection
